<template>
  <card-template-v2 class="common-dashboard-card">
    <template #header>
      <div class="flex-row flex__between" style="width: 100%">
        <slot name="header"></slot>
        <!-- <el-tooltip content="Xem thêm" placement="top"> -->
        <i
          @click="$emit('removeItem')"
          style="margin-right: 10px"
          class="fal fa-times color__smoke clickable"
        ></i>
        <!-- </el-tooltip> -->
      </div>
    </template>

    <template #body>
      <VuePerfectScrollbar class="scroll-area">
        <template v-if="isDataFound">
          <slot name="body"></slot>
        </template>
        <div v-else class="flex-row flex__center" style="height: 100%">
          <i
            class="fas fa-ban color__silver font-size__larger margin-right-10"
          ></i>
          <span class="font-size__medium font-weight__bold opacity-50"
            >Không có dữ liệu
          </span>
        </div>
      </VuePerfectScrollbar>
    </template>
  </card-template-v2>
</template>
<script>
import CardTemplateV2 from "./card-template-v2";

export default {
  name: "common-dashboard-card-template",
  props: ["isDataFound"],
  components: {
    CardTemplateV2,
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },
  methods: {
    removeItem() {
      this.$emit("removeItem");
    },
  },
};
</script>

<style scoped>
.common-dashboard-card {
  /* height: 300px; */
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/layout/common-dashboard-card-template.vue